<mat-dialog-content class="mat-typography TC_container add-team-model" id="teamsAddModal">
  <div class="section_login">

    <button style="outline: none;" class="close-button forgetPass" (click)="CloseModal()" [mat-dialog-close]="true"
      id="closeBtn">
      <img src="../../../assets/icons/x-button.svg">
    </button>

    <div class="row row-add-model">


      <div class="col-sm-12">
        <p class="authHeadText" *ngIf="this.data.userType.access == 'add'">Add team</p>
        <p class="authHeadText" *ngIf="this.data.userType.access == 'edit'">Edit Team</p>
      </div>

      <div class="col-md-12 text-center">
        <form [formGroup]="addTeamForm">

          <img [src]="imgURL" *ngIf="imgURL =='assets/icon/add-team.png'" alt="" class="profile-pic" height="150"
            width="150">
          <img alt="" [defaultImage]="defaultImage" *ngIf="imgURL !='assets/icon/add-team.png'" [lazyLoad]="imgURL"
            class="profile-pic" height="150" width="150">
          <div class="edit-icon">
            <label for="files" class="fileUploadInput">
              <img src="../../../../assets/icons/edit-circle.png" alt="">
            </label>
            <!-- <input type="file" id="files" (change)="onChangeimg($event)" accept="image/*"
              style="visibility:hidden; height: 1px;"> -->
            <input type="file" id="files" (click)="onClickFile()" (change)="openProfilePictureModal($event)"
              accept="image/*" style="visibility:hidden; height: 1px;">
          </div>

          <mat-form-field class="example-full-width authSignIn">
            <mat-label><span *ngIf="!addTeamForm.value.addteamName">Enter team name</span>
            </mat-label>
            <input matInput placeholder="" formControlName="addteamName">
          </mat-form-field>
          <mat-form-field class="example-full-width authSignIn">
            <mat-label><span *ngIf="!addTeamForm.value.addteamSize">Enter team size</span>
            </mat-label>
            <input matInput placeholder="" formControlName="addteamSize">
          </mat-form-field>

          <div *ngIf="data.userType.team" class="edit-manage-team">
            <div class="d-flex justify-content-between" *ngIf="data.userType.team">
              <span class="player-joined">Players Joined</span>
              <span class="player-joined total-team">{{playersList?.players?.length ? playersList?.players?.length :
                0}}</span>
            </div>

            <div class="addPlayer">
              <button (click)="openAddPlayerModal()" [mat-dialog-close]="true">Add Players</button>
            </div>

            <div class="">
              <div *ngFor="let i of playersList.players;let index = index" class="teamPlayers">
                <div class="">
                  <span><img [src]="i?.profilePicture ? i?.profilePicture : '../../../assets/icons/img_avatar.png'"
                      alt="" class="player-img"></span>
                  <span class="playerName" style="">{{checkResolution(i?.firstName, i?.lastName)}}</span>

                </div>
                <div>
                  <div class="deleteImage">
                    <img src="../../../../assets/SVG/delete-team.svg" alt="" (click)="deletePlayer(i?._id, index)">
                  </div>
                </div>


              </div>
            </div>
          </div>

          <div class="col-md-12">
            <button mat-raised-button color="warn" *ngIf="this.data.userType.access == 'add'" [mat-dialog-close]="true"
              (click)="addTeanFNCall()" class="authSignIn"
              [disabled]="this.addTeamForm.value.addteamName == '' || this.addTeamForm.value.addteamName == undefined">Add
              Team</button>
            <!-- || imgURL == '' || imgURL == 'assets/icons/profile-default.png' || !fileName -->
            <button mat-raised-button color="warn" *ngIf="this.data.userType.access == 'edit'" [mat-dialog-close]="true"
              (click)="UpdateTeanFNCall()"
              [disabled]="addTeamForm.invalid || addTeamForm.pristine && (playerDeleted==true && profileChanged==true)"
              class="authSignIn update-team-club">Save</button>

            <!-- <button mat-raised-button color="warn" *ngIf="this.data.userType.access == 'edit_mt'" [mat-dialog-close]="true"
              (click)="UpdateTeamMTFNCall()" class="authSignIn update-team-club">Update Team</button> -->
          </div>
        </form>
      </div>


    </div>
  </div>
</mat-dialog-content>


<ng-template #ProfilePicCropModal>
  <div class="modal-header profile-picture-organiser1" style="padding: 20px;">
    <h4 style="color: #00006A;" id="profilePic">Profile Picture</h4>
  </div>
  <div class="modal-body" style="padding: 20px;">
    <div class="profile-crop">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [imageURL]="profilePicCropperUrl"
        [maintainAspectRatio]="true" [aspectRatio]="1 / 1" format="png" [transform]="imageTransform"
        (imageCropped)="croppedProfilePicture($event)"></image-cropper>
    </div>
    <div style="padding-top: 10px; float: right;">
      <button class="s-button" (click)="uploadProfile()">Done</button>
      <button class="c-button" (click)="modalRef.hide()" style="margin-left: 30px;">Cancel</button>
    </div>
  </div>
</ng-template>